import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import LoginPage from './components/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';

import HomePage from './pages/HomePage';
import AllProductsPage from './pages/AllProductsPage';
import MyProductsPage from './pages/MyProductsPage';
import MyBusinessesPage from './pages/MyBusinessesPage';
import MyOffersPage from './pages/MyOffersPage';
import UpdatesListPage from './pages/UpdatesListPage';
import ReportsPage from './pages/ReportsPage';
import TestChatPage from './pages/TestChatPage';
import './App.css';

class App extends Component {
  renderProtectedPage(pageComponent) {
    return (
      <ProtectedRoute>
        <AppLayout>{pageComponent}</AppLayout>
      </ProtectedRoute>
    );
  }
  

  render() {
    return (
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />

            <Route path="/" element={this.renderProtectedPage(<HomePage />)} />
            <Route
              path="/all-products"
              element={this.renderProtectedPage(<AllProductsPage />)}
            />
            <Route
              path="/my-products"
              element={this.renderProtectedPage(<MyProductsPage />)}
            />
            <Route
              path="/my-businesses"
              element={this.renderProtectedPage(<MyBusinessesPage />)}
            />
            <Route
              path="/my-offers"
              element={this.renderProtectedPage(<MyOffersPage />)}
            />
            <Route
              path="/updates"
              element={this.renderProtectedPage(<UpdatesListPage />)}
            />
            <Route
              path="/reports"
              element={this.renderProtectedPage(<ReportsPage />)}
            />
            <Route
              path="/test-chat"
              element={this.renderProtectedPage(<TestChatPage />)}
            />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    );
  }
}

export default App;